import { Title, SubTitle, CustomLink, Row, Col, Shape, styled, CommonStyles } from '@teko/ds-desktop';
import { RightOutlined } from '@teko/ds-icon';
import React from 'react';
import { t } from '../../../i18n.es.js';
import { getTrackingData } from '@teko/tracking';
import { NextImage } from '../../NextImage.es.js';
import { ProductCarousel } from '../../ProductCarousel/ProductCarousel.es.js';
import { Countdown } from '../../Countdown/Countdown.es.js';

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const HotDealTab = (_a) => {
  var _b = _a, {
    tabs,
    activeTabId,
    productsCarousel,
    handleChangeTab,
    className
  } = _b, props = __objRest(_b, [
    "tabs",
    "activeTabId",
    "productsCarousel",
    "handleChangeTab",
    "className"
  ]);
  const activeTab = tabs.find((tab) => tab.id === activeTabId);
  if (!activeTab)
    return null;
  return /* @__PURE__ */ React.createElement(TabWrapper, __spreadValues({}, props), /* @__PURE__ */ React.createElement(NextImage, {
    style: {
      borderRadius: "5px 5px 0 0"
    },
    layout: "fill",
    src: activeTab.backgroundImage || "",
    alt: activeTab.title,
    priority: true,
    objectFit: "cover",
    objectPosition: "top left"
  }), /* @__PURE__ */ React.createElement(TabHeader, null, tabs.map((tab, index) => /* @__PURE__ */ React.createElement(TabItem, __spreadValues({
    key: tab.id,
    "data-index": index,
    onClick: () => handleChangeTab(tab.id),
    className: tab.id === activeTab.id ? "active" : ""
  }, getTrackingData({
    isTrackContent: true,
    regionName: "hotDealTab",
    contentName: tab.title
  })), /* @__PURE__ */ React.createElement(Title, {
    line: 1,
    style: { textAlign: "center" }
  }, tab.title), tab.description && /* @__PURE__ */ React.createElement(SubTitle, {
    line: 1,
    style: { textAlign: "center" }
  }, tab.description)))), /* @__PURE__ */ React.createElement("div", {
    style: { position: "relative", textAlign: "right", padding: "20px" }
  }, (activeTab == null ? void 0 : activeTab.link) && /* @__PURE__ */ React.createElement(CustomLink, {
    href: activeTab.link
  }, /* @__PURE__ */ React.createElement("span", {
    style: { color: "white" }
  }, t("Xem t\u1EA5t c\u1EA3")), /* @__PURE__ */ React.createElement(RightOutlined, {
    color: "white"
  }))), /* @__PURE__ */ React.createElement(Row, null, /* @__PURE__ */ React.createElement(Col, {
    span: 2,
    style: { margin: "auto" }
  }, /* @__PURE__ */ React.createElement(CountdownTime, {
    date: activeTab.endAt
  })), /* @__PURE__ */ React.createElement(Col, {
    span: 10
  }, /* @__PURE__ */ React.createElement(Carousel, null, Object.keys(productsCarousel).length ? /* @__PURE__ */ React.createElement(ProductCarousel, __spreadProps(__spreadValues({}, productsCarousel), {
    regionName: "hotDeal",
    key: activeTab.id
  })) : /* @__PURE__ */ React.createElement(Shape, {
    height: 300
  })))));
};
const TabWrapper = styled.div`
  ${CommonStyles}
  position: relative;
  overflow: hidden;
  padding-bottom: 12px;
`;
const TabHeader = styled.div`
  height: 60px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 8px 8px 0px 0px;
`;
const TabItem = styled.div(({ theme }) => `
  height: 60px;
  padding: 0.5rem 1rem 0 1rem;
  border-radius: 5px 5px 0 0;
  flex: 1;
  cursor: pointer;
  background: white;
  color: ${theme == null ? void 0 : theme.colors.textPrimary};
  position: relative;
  &.active {
    background: transparent;
    color: white;
  }
  &:not(:first-child):before {
    content: '';
    width: 0;
    height: 0;
    border-left: 5px solid transparent;
    border-right: 5px solid transparent;
    border-top: 5px solid white;
    position: absolute;
    left: -5px;
    top: 0;
  }
`);
const CountdownTime = styled(Countdown)`
  position: relative;
  left: 1rem;
  bottom: 0;
`;
const Carousel = styled.div`
  margin-left: 48px;
  margin-right: 16px;
`;

export { HotDealTab };
